import { Component } from '@angular/core';
import { BnNgIdleService } from 'bn-ng-idle';
import { HeaderComponent } from './core';
import { OrderPipe } from 'ngx-order-pipe';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
    providers: [OrderPipe] // Add this line

})
export class AppComponent {
//  public userLogged = localStorage.getItem('userLoggedin')
//   constructor(private bnIdle: BnNgIdleService ,private header:HeaderComponent ) { // initiate it in your component constructor
//     if(localStorage.getItem('userLoggedin') == 'true'){
//       this.bnIdle.startWatching(5).subscribe((res) => {
//         if(res) {
//             //this.userLogged = 'false'
//             this.header.logout()
//         }
//       })
//     }else{ 
//     }
    
//   }

  constructor(){}

  ngOnInit(){ 
  }
}
